<template>
	<form @submit.prevent="onSubmitForm">
		<div class="finish-section divided">
			<span class="grow-one">Ticket afgerond op</span>
			<div class="grow-one">
				<date-field v-if="supportTicket.phase === 'FINISHING'" v-model="resolvedAt" value-format="yyyy-mm-dd" placeholder="01-01-2022"></date-field>
				<div class="remark-field" v-if="supportTicket.phase === 'FINISHED'">{{ parseDate(resolvedAt) }}</div>
				<span class="error-message" v-if="this.errors.includes('resolvedAt')">Mag niet leeg zijn</span>
			</div>
			<div class="grow-two">
				<textarea v-model="resolvedRemarks" rows="1" :disabled="supportTicket.phase === 'FINISHED' || isLoading" placeholder="Laatste notitie voor tijdens het afronden"></textarea>
			</div>
		</div>
		<div class="button-container">
			<button v-if="supportTicket.phase === 'FINISHING'" class="delete-button" :disabled="isLoading" type="button" ref="cancelSupportAppointmentButton" @click="cancelSupportAppointment"><Trash2Icon></Trash2Icon></button>
			<Button v-if="supportTicket.phase === 'FINISHING'" class="primary submit button" :disabled="isLoading" type="submit" ref="submitButton">OPSLAAN</Button>
		</div>
	</form>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { client } from "../../store";
import { validateNotEmptyOrEmptyString } from "../../common/validators";
import DateField from "../DateField.vue";
import { parseDate } from "../../utils";
import Trash2Icon from "vue-feather-icons/icons/Trash2Icon";
import CancelModal from "./CancelModal.vue";

export default {
	name: "FinishDetail",
	components: {Trash2Icon, DateField},

	computed: {
		...mapState({
			isLoading: "loading"
		})
	},

	props: {
		supportTicket: null,
		finishStep: null
	},

	data() {
		return {
			resolvedAt: '',
			resolvedRemarks: '',
			errors: []
		}
	},

	methods: {
		parseDate: parseDate,

		...mapActions({
			setLoading: "map/setLoading",
			setIdle: "map/setIdle"
		}),

		onSubmitForm() {
			if (this.supportTicket.phase === "FINISHED") {
				return;
			}

			if (validateNotEmptyOrEmptyString(this.resolvedAt) === false) {
				this.errors.push('resolvedAt');
			} else {
				this.errors = this.errors.filter(error => error !== 'resolvedAt');
			}

			if (this.errors.length > 0) {
				return;
			}

			this.setLoading();

			client.query(`
				mutation($support_ticket_id: ID!, $resolved_at: String, $resolved_remarks: String) {
					updateSupportTicket(support_ticket_id: $support_ticket_id, resolved_at: $resolved_at, resolved_remarks: $resolved_remarks)
				}
			`, {
				support_ticket_id: this.supportTicket.id,
				resolved_at: this.resolvedAt,
				resolved_remarks: this.resolvedRemarks.trim()
			}).then(() => {
				this.$notify({
					group: "app",
					title: "Support ticket updaten",
					type: "success",
					text: "Support ticket is succesvol aangepast"
				});

				this.setIdle();
				this.finishStep(false);
			}).catch((error) => {
				this.setIdle();

				this.$notify({
					group: "app",
					title: "Status updaten",
					type: "error",
					text: error
				});
			});
		},

		cancelSupportAppointment() {
			this.$modal.show(CancelModal, {
				supportTicket: this.supportTicket,
				finishStep: this.finishStep
			}, {
				classes: 'modal',
				adaptive: true,
				scrollable: true,
				width: '100%',
				height: 'auto',
				maxWidth: 600
			});
		}
	},

	beforeMount() {
		if (validateNotEmptyOrEmptyString(this.supportTicket.resolved_at)) {
			this.resolvedAt = this.supportTicket.resolved_at;
			this.resolvedRemarks = this.supportTicket.resolved_remarks;
		}
	}
}
</script>

<style scoped lang="scss">

.button {
	text-align: center;
	padding: 8px 12px;
	border-radius: 4px;
	font-size: 1em;
	display: inline;
	font-weight: 425;
	width: 100%;

	background-color: #35a5a4;
	color: white;
	border: none;
}

.grow-one {
	width: 45%;
}

.grow-two {
	width: 100%;
}

textarea {
	width: 100%;
	height: auto;
	margin: 0;
	border: 2px solid #d2d2d2;
	box-shadow: none;
	color: #666;
	background-color: #fff;
	box-sizing: border-box;
	border-radius: 5px;
	padding: 0.5em;
	font-size: 1rem;
}

textarea:focus {
	background-color: #fff;
}

.remark-field, ::v-deep > .DateField .DateField__group .TextField {
	border: 2px solid #d2d2d2;
	border-radius: 5px;
	box-shadow: none;
	margin: 0;
	padding: 0.5em;
	background-color: #fff;
	font-size: 1rem;
}

form {
	display: flex;
	flex-direction: column;
	gap: 24px;
}

.primary.submit.button {
	width: 20%;
	align-self: end;
}

.finish-section {
	padding-top: 24px;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	gap: 40px;
}

.divided {
	border-top: 2px solid #d2d2d2;
	margin-top: 24px;
}

.button-container {
	display: flex;
	flex-direction: row;
	justify-content: end;
	gap: 16px;
}

.delete-button {
	background-color: #d3455b;
	color: #ffffff;
	aspect-ratio: 1/1;
	text-align: center;
	border-radius: 5px;
	box-shadow: 0 2px 1px -2px rgb(0 0 0 / 50%);
	display: flex;
	align-items: center;
	justify-content: center;
	border: none;
}

.error-message {
	display: block;
	margin-top: 8px;
	color: red;
}

span {
	display: inline-flex;
	align-items: center;
}
</style>
